// extracted by mini-css-extract-plugin
export default {"modal":"CommentsModal_modal__4lYTf","content":"CommentsModal_content__qzwE0","formContainer":"CommentsModal_formContainer__wi4iE"};